import axios from 'axios';
import Cookies from 'js-cookie';
import { expirationTokenAuth } from "./jwtUtils";

const apiInterceptor = axios.create({
    baseUrl: process.env.REACT_APP_API_ESPOL_ADS,
});

apiInterceptor.interceptors.request.use(
    (config) => {
        const token = Cookies.get('tokenEspolAds');
        if(token){
            if (expirationTokenAuth(token)) {
                // Token expirado: borrar la cookie y redirigir
                Cookies.remove('tokenEspolAds');
                console.warn('Token caducado. Se ha eliminado la cookie.');

                // Opcional: Redirige al login
                window.location.href = '/';

                // Cancela la solicitud lanzando un error
                return Promise.reject(new axios.Cancel('Token caducado'));
            }
            config.headers.Authorization = `Bearer ${token}`;            
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default apiInterceptor;